import { Redirect } from 'expo-router';

export default function PayOverTimeIndex() {
  return <Redirect href="/" />;
}
